import { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from './_http';

// 더보기 - 공지사항 조회
type GetMasterListDataType = Ref<{
	notice_division: string;
	page: number;
	view: number;
}>;
type mustread = {
	mustread_pk: number;
	mustread_title: string;
	mustread_enrollment_date: string;
	mustread_modifying_date: string;
};

type GetMasterListResType = {
	mustread: mustread[];
	mustread_count: number;
};
export const useGetMustreadListDataApi = (params: GetMasterListDataType) => {
	const url = '/v1/front/getMustreadList';
	return useQuery<AxiosResponse, AxiosError, GetMasterListResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data.data,
	});
};

// 더보기 - 공지사항 상세 조회
type GetMustreadDetailDataType = {
	mustread_pk: string;
};
type mustreadDetail = {
	mustread_pk: number;
	authority_group_name: string;
	mustread_title: string;
	mustread_content: string;
	mustread_enrollment_date: string;
	mustread_modifying_date: string;
	mustread_hit: number;
};

type GetMustreadDetailResType = {
	mustread: mustreadDetail;
};
export const useGetMustreadDetailDataApi = (params: GetMustreadDetailDataType) => {
	const url = '/v1/front/getMustreadDetail';
	return useQuery<AxiosResponse, AxiosError, GetMustreadDetailResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
	});
};

export const useGetMustreadDetailDataApiByComputed = (params: Ref<GetMustreadDetailDataType>) => {
	const url = '/v1/front/getMustreadDetail';
	return useQuery<AxiosResponse, AxiosError, GetMustreadDetailResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data.data,
	});
};
